<template>
  <InputSelect
    :name="name"
    :classes="classes"
    :label="label"
    :help="help"
    :isDisabled="isDisabled"
    :isRequired="isRequired"
    :focusOnMount="focusOnMount"
    v-model="value"
    :options="socialPlatformsList"
  ></InputSelect>
</template>

<script>
import { mapGetters } from 'vuex';
import Generator from '@/services/generator/GeneratorService';
import InputMixin from '../InputMixin';

export default {
  name: 'InputSocialPlatform',
  mixins: [
    InputMixin,
  ],
  computed: {
    ...mapGetters(['socialPlatforms']),
    socialPlatformsList() {
      return this.socialPlatforms.map((d) => ({
        v: d,
        n: this.$t(`social_platform.${d}`),
      })).sort(Generator.nameSort);
    },
  },
};
</script>
